export default __webpack_public_path__ + "static/media/image.dreamspace-academy.1f6b596a.png";